export default class OrderFuelModel {
    constructor() {
        this.petraId = undefined;
        this.adBlueLpg = false;
        this.anwimDelivery = false;
        this.ownDelivery = false;

        this.remarks = '';
        this.carrierEmail = '';

        this.deliveryDate = undefined;
        this.draft = undefined;
        this.draftName = '';
        this.driver = undefined;
        this.vehicle = undefined;
        this.trailer = undefined;
        this.transportType = undefined;
        this.orderType = undefined;
        this.purpose = undefined;
        this.partner =undefined;
        this.werks = undefined;
        this.sentNumber = '';
        this.fuels = [];
        this.documentNumber = '';
        this.documentDate = undefined;
        this.amountNetto = undefined;
        this.amountVat = undefined;
        this.amount = undefined;
        this.status = undefined;
    }

    static assign(from, to, t) {
        if (from) {
            to.petraId = from.petraId;
            to.adBlueLpg = from.adBlueLpg;
            to.anwimDelivery = from.anwimDelivery;
            to.ownDelivery = from.ownDelivery;
            to.remarks = from.remarks;
            to.carrierEmail = from.carrierEmail;
            to.deliveryDate = from.deliveryDate ? new Date(from.deliveryDate) : undefined;
            to.draft = from.draft;
            to.draftName = from.draftName;
            to.vehicle = from.vehicle;
            to.driver = from.driver;
            to.trailer = from.trailer;
            to.transportType = from.transportType;
            to.orderType = from.orderType;
            to.purpose = from.purpose;
            to.partner = from.partner;
            to.werks = from.werks;
            to.sentNumber = from.sentNumber;
            to.fuels = from.fuels ? from.fuels : [];
            to.documentNumber = from.documentNumber;
            to.documentDate = from.documentDate ? new Date(from.documentDate) : undefined;
            to.amountNetto = from.amountNetto;
            to.amountVat = from.amountVat;
            to.amount = from.amount;
            to.status = from.status;
        } else {
            to = new OrderFuelModel();
        }
    }

    static copy(from, t) {
        const to = new OrderFuelModel();
        OrderFuelModel.assign(from, to, t);
        return to;
    }
}
